module.exports = __webpack_public_path__ + "static/media/banner.a952fde8.png";